<!-- 创建时间2023/06/20 09:08:08 -->
<!-- 创建人：Zhao bing bing -->
<!-- 组件描述单独：独立权限选择 -->
<template>
  <div>
    <yxt-select
      class="width-percent-100-i"
      v-model="permissions_"
      multiple
      :placeholder="$t('pc_select_placeholder'/** 请选择 */)"
      icon-name="more"
      hidden-option
      collapse-tags
      value-key="userGroupId"
      prop-label="userGroupName"
      size="small"
      :disabled="disabled"
      @click.native="open"
    >
      <template slot="tag" slot-scope="{ data }">
        <div class="yxtbiz-flex-center">
          <yxt-svg
            width="16px"
            height="16px"
            class="mr4"
            :icon-class="getSvgName(data.value)"
          />
          <span>{{ data.currentLabel }}</span>
          <yxt-tooltip
            v-if="data.value.groupType === 5"
            effect="dark"
            :content="data.value.includeChildDept ? $t('pc_kng_dept_includeAll_true' /* 当前部门及后续新增子部门*/) : $t('pc_kng_dept_includeAll_false' /* 仅当前部门*/)"
            placement="top"
          >
            <yxt-svg
              class="hand color-gray-6 hover-primary-6 v-middle"
              width="16px"
              height="16px"
              icon-class="question-cirlce-o"
            />
          </yxt-tooltip>
        </div>
      </template>
    </yxt-select>
    <!-- 部门(0)，岗位(1)，用户组(2)，角色(3),职级(4), 人员(5), 直属(6) -->
    <yxt-drawer size="960px" destroy-on-close :visible.sync="visible">
      <yxtbiz-range-selector
        ref="selector"
        v-model="authList"
        :tabs="[
          { type: 'userGroup' },
          { type: 'department', childrenIncluded: true },
          'position',
          'role',
          'persons'
        ]"
        :functionCode="functionCode"
        :dataPermissionCode="dataPermissionCode"
      ></yxtbiz-range-selector>
      <div slot="footer">
        <yxt-button plain @click="cancel">
          {{ $t('pc_kng_common_btn_cancel') }}
        </yxt-button>
        <yxt-button type="primary" @click="confirm">
          {{ $t('pc_kng_common_btn_confirm') }}
        </yxt-button>
      </div>
    </yxt-drawer>
  </div>
</template>

<script>
// nodeType 组件值, groupType 接口值
const transConfigs = [
  { nodeType: 'userGroup', groupType: 2, icon: 'usergroup' }, // 用户组
  { nodeType: 'department', groupType: 5, icon: 'common_dept' }, // 部门
  { nodeType: 'position', groupType: 6, icon: 'position' }, // 岗位
  { nodeType: 'role', groupType: 7, icon: 'role' }, // 角色
  { nodeType: 'persons', groupType: 8, icon: 'person-center' } // 人员
];
const getNodeTypeWithGroupType = val => {
  const obj = transConfigs.find(item => item.groupType === val);
  return obj && obj.nodeType;
};
const getGroupTypeWithNodeType = val => {
  const obj = transConfigs.find(item => item.nodeType === val);
  return obj && obj.groupType;
};
export default {
  name: 'auth-selector',
  inject: ['getFunctionCode'],
  props: {
    permissions: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    dataPermissionCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      authList: []
    };
  },
  computed: {
    functionCode() {
      return this.getFunctionCode();
    },
    permissions_: {
      get() {
        return this.permissions;
      },
      set(val) {
        this.$emit('update', val);
      }
    }
  },
  methods: {
    getSvgName(obj) {
      const config = transConfigs.find(
        item => item.groupType === obj.groupType
      );
      return config && config.icon;
    },
    open() {
      this.authList = this.permissions.map(item => {
        return {
          nodeType: getNodeTypeWithGroupType(item.groupType),
          id: item.userGroupId,
          fullname: item.userGroupName,
          name: item.userGroupName,
          includeAll: item.includeChildDept
        };
      });
      this.visible = true;
    },
    cancel() {
      this.visible = false;
    },
    confirm() {
      this.$refs.selector.getSelectDataArray().then(result => {
        const permissions = result.map(item => {
          return {
            groupType: getGroupTypeWithNodeType(item.nodeType),
            id: item.id, // 保存接口使用的属性
            userGroupId: item.id,
            userGroupName: item.name || item.fullname,
            includeChildDept: item.includeAll
          };
        });
        this.$emit('update', permissions);
        this.visible = false;
      });
    }
  }
};
</script>